export default "__VITE_ASSET__CJh3YcQ1__ 400w, __VITE_ASSET__D645JEJk__ 800w, __VITE_ASSET__CSMxwwZW__ 1200w";